import { useQuery } from '@tanstack/react-query';

import { type AnalyticsSearchStatsParams, getAnalyticsSearchCounts } from '~/services/AnalyticsService';

import { analyticsQueryKeys } from './analyticsQueryKeys';

export function useGetAnalyticsSearchCounts(params: AnalyticsSearchStatsParams | null) {
  const query = useQuery({
    queryKey: params ? analyticsQueryKeys.counts(params) : analyticsQueryKeys.countsIdle(),
    queryFn: async ({ signal }) => getAnalyticsSearchCounts(params!, { signal }),
    enabled: params !== null,
    retry: false,
  });

  return { data: query.data, isFetching: query.isFetching, error: query.error, refetch: query.refetch };
}
